import styled from 'styled-components';

export const HeaderContainer = styled.div`
  margin: 0px;
  justify-content: space-between;
  padding-bottom: 8px;
  align-items: center;
  display: flex;
`;

export const Avatar = styled.img`
  width: 36px;
  height: 36px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 50%;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 1px;
`;

export const AssistantName = styled.div`
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.default};
  color: ${({ theme }) => theme.color.assistantMessage};
`;

export const AiBadgeContainer = styled.div`
  min-width: 1px;
  padding-left: 8px;
  padding-right: 8px;
  gap: 4px;
  display: flex;
`;

export const AiBadge = styled.div`
  margin-left: auto;
  font-size: ${({ theme }) => theme.font.size.small};
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.color.assistantMessage};
  border-radius: 2px;
  color: ${({ theme }) => theme.color.assistantMessage};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
`;

